jQuery(document).ready(function(){
  // Gestion du bouton de recherche
  const searchButton = document.querySelector('.search-bar-container-button');
  const searchContainer = document.querySelector('.search-bar-container');

  if (searchButton && searchContainer) {
    searchButton.addEventListener('click', function() {
      searchContainer.classList.toggle('show');
    });
  }

  if(jQuery('#slider-home-page').length > 0) {
    const swiperEl = document.querySelector("#slider-home-page .slider-home-page");

    //slider-home-page
    new Swiper("#slider-home-page .slider-home-page", {
      slidesPerView: 1,
      spaceBetween: 30,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: swiperEl.querySelector('.swiper-pagination'),
        clickable: true,
        renderBullet: function (index, className) {
          const number = (index + 1).toString().padStart(2, '0');
          return `<span class="${className}">${number}</span>`;
        }
      },
    });

    //notre reseau
    new Swiper("#notre-reseau .slider-regions", {
      slidesPerView: 2,
      spaceBetween: 10,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        1600: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        1800: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
      },

      navigation: {
        nextEl: ".swiper-button-prev",
        prevEl: ".swiper-button-next",
      },
    });

    //Nos projects image hover effect

    const $projectLiItems = jQuery('#projects-home-page .projects li');
    $projectLiItems.on('click', function () {
      // Remove active state + hide all images
      jQuery('#projects-home-page .projects li')
        .removeClass('active')
        .find('.views-field-field-visuel-projet')
        .hide();

      // Activate clicked row + show its image
      jQuery(this)
        .addClass('active')
        .find('.views-field-field-visuel-projet')
        .fadeIn(200);
    });
    $projectLiItems.first().click();
  }
  (function () {
    const slider = document.querySelector('#slider-home-page');
    const projects = document.querySelector('#projects-home-page');

    if (!slider || !projects) return;

    window.addEventListener('scroll', function () {
      const scrollY = window.scrollY;
      const sliderHeight = slider.offsetHeight;

      if (scrollY < sliderHeight) {
        const swiperContent = slider.querySelector('.swiper-wrapper');
        if (swiperContent) {
          swiperContent.style.transform = `translateY(${scrollY * 0.3}px)`;
        }
      }
    });
  })();
})
